import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import withStyles from "@material-ui/core/styles/withStyles";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import classNames from "classnames";
import get from "lodash/get";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../../Actions/AxiosInstance";
import { setHelperText } from "../../../../Actions/commonAction";
import { DateConversion } from "../../../../Utils/dates";
import { ChangeLanguage } from "../../../../Actions/LanguageAction";
import ActiveIcon from "../../../../Assets/Images/aaa.png";
import createstore from "../../../../store";
import { getFormattedDate } from "../../../../Utils";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  tabheading: {
    fontSize: 16,
    textTransform: "capitalize",
    padding: 0,
  },
  button: {
    margin: theme.spacing.unit,
  },
});

class UpdateOPtionalHoliday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOptions: [],
      originalOptions: [],
      errors: {},
      holidayList: [],
      deletedOptions: [],
      leaveTypes: [],
      categorieTypes: "",
      isDisabled: false,
      isDisabelSaveButton: false,
      employeeid: "",
      Expirydate: "",
      dayfornewemp: "",
      doj: "",
      today: new Date(),
      maxoptlimit: "",

      // actionidlist :this.props.history.location.state.actionidlist
    };
  }

  componentWillMount() {
    this.props.ChangeLanguage("optionalholiday,navigation");
    this.getOptionalHolidayList();
    this.initemployeeoptionalholiday();
    const { AuthenticationAction } = createstore.getState();
    const { SubscriptionInfo } = createstore.getState();
    const DateFormat = get(
      SubscriptionInfo,
      "SubscriptionData.dateformatname",
      "",
    );
    // let DateFormat = AuthenticationAction.login.dateformat;
    let ShortDateFormat = DateFormat.split(" ");
    ShortDateFormat = ShortDateFormat[0];
    this.setState({ ShortDateFormat });
  }

  getOptionalHolidayList() {
    instance
      .post("leaves/getemployeeholiday/2")
      .then((result) => {
        let holidayList = [];
        const selectedOptions = [];
        const originalOptions = [];
        result.data.result.length > 0
          ? (holidayList = result.data.result)
          : (holidayList = []);
        if (holidayList.length > 0) {
          holidayList.map((item) => {
            if (item.isselected == true) {
              selectedOptions.push(item);
            }
          });
        }
        if (holidayList.length > 0) {
          holidayList.map((item) => {
            if (item.isselected == true) {
              originalOptions.push(item);
            }
          });
        }
        this.setState({ holidayList, selectedOptions, originalOptions });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  HandleMultiSelect = (selectedOption, flag) => {
    const index = this.state.selectedOptions.findIndex(
      (item) => item.holidayid == selectedOption.holidayid,
    );
    const { selectedOptions } = this.state;
    const { deletedOptions } = this.state;
    if (index == -1) {
      if (this.state.selectedOptions.length < this.state.maxoptlimit) {
        selectedOptions.push(selectedOption);
      } else {
        this.props.enqueueSnackbar(
          `You can't select max ${this.state.maxoptlimit} optional holidays.`,
          { variant: "error" },
        );
      }
    } else {
      selectedOptions.splice(index, 1);
      deletedOptions.push(selectedOption);
    }
    this.setState({ selectedOptions, deletedOptions });
  };

  OnCancel() {
    this.props.history.push(`../holiday`);
  }

  getDate(dataString) {
    return DateConversion(dataString, this.state.ShortDateFormat);
  }

  add_Days = (dayfornewemp, doj) => {
    const dat = new Date(doj);
    dat.setDate(dat.getDate() + dayfornewemp);
    return dat;
  };

  initemployeeoptionalholiday() {
    instance
      .post("/leaves/initemployeeoptionalholiday")
      .then((result) => {
        const { maxoptlimit } = result.data.result[0];
        const { dayfornewemp } = result.data.result[0];
        const { doj } = result.data.result[0];
        const { lastdateexistingemp } = result.data.result[0];
        this.setState({
          maxoptlimit,
          dayfornewemp,
          doj,
          lastdateexistingemp,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  onSaveClick() {
    let selectedHolidays = [];
    let deletedOptions = [];
    // const changedata = this.state.selectedOptions.map(x =>
    //   this.state.holidayList.findIndex(x1 => x.holidayid == x1.holidayid && x.isselected != x1.isselected)
    // )
    const changedata =
      JSON.stringify(this.state.originalOptions) ===
      JSON.stringify(this.state.selectedOptions);
    console.log("changedata: ", changedata);
    selectedHolidays = this.state.selectedOptions.filter(
      (op) =>
        this.state.originalOptions.findIndex(
          (hol) => hol.holidayid == op.holidayid,
        ) == -1,
    );

    selectedHolidays = selectedHolidays.map((op) => op.holidayid);

    deletedOptions = this.state.originalOptions.filter(
      (op) =>
        this.state.selectedOptions.findIndex(
          (hol) => hol.holidayid == op.holidayid,
        ) == -1,
    );

    deletedOptions = deletedOptions.map((op) => op.holidayid);

    const data = {
      holidayyear: this.state.holidayList[0].holidayyear,
      holidayplanid: this.state.holidayList[0].holidayplanid,
      addholidayids: selectedHolidays.length < 1 ? null : selectedHolidays,
      deleteholidayids: deletedOptions.length < 1 ? null : deletedOptions,
    };
    let Expirydate;
    const today = moment(this.state.today).format("YYYY-MM-DD");
    if (
      parseInt(moment(today).format("MM")) ==
      parseInt(moment(this.state.doj).format("MM"))
    ) {
      if (this.state.dayfornewemp) {
        Expirydate = this.add_Days(this.state.dayfornewemp, this.state.doj);
        Expirydate = moment(Expirydate).format("YYYY-MM-DD");
      } else {
        const ss = today.split("-");
        Expirydate = `${ss[0]}-12-31`;
      }
    } else {
      Expirydate = this.state.lastdateexistingemp;
    }
    if (
      JSON.stringify(
        this.state.originalOptions.sort((a, b) => a.holidayid - b.holidayid),
      ) ===
      JSON.stringify(
        this.state.selectedOptions.sort((a, b) => a.holidayid - b.holidayid),
      )
    ) {
      this.props.enqueueSnackbar("No changes are made to Save", {
        variant: "error",
      });
    } else if (today <= Expirydate) {
      if (!this.state.isDisabelSaveButton) {
        this.setState({ isDisabelSaveButton: true });
        instance
          .post("/leaves/createemployeeoptionalholiday", data)
          .then((result) => {
            this.props.enqueueSnackbar(
              " Optional holidays updated successfully",
              {
                variant: "success",
              },
            );

            this.setState(
              {
                isDisabelSaveButton: false,
              },
              () => this.props.history.push(`../holiday`),
            );
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    } else {
      Object.assign(data, {
        sendersourceid: 1,
        requeststatusid: 1,
        recipientjson: null,
      });

      if (!this.state.isDisabelSaveButton) {
        this.setState({ isDisabelSaveButton: true });
        instance
          .post("/leaves/createoptionalholidayrequest", data)
          .then((result) => {
            this.props.enqueueSnackbar(
              " Optional holiday request sent successfully",
              {
                variant: "success",
              },
            );
            this.setState(
              {
                isDisabelSaveButton: false,
              },
              () => this.props.history.push(`../holiday`),
            );
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  }

  render() {
    const { isDisabled } = this.state;
    const { selectedOptions } = this.state;
    const language = this.props.Language.optionalholiday;
    let selectedOption;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="content-outer-wrapper">
          <Grid container>
            <Grid item xs={12} md={8} sm={12}>
              <div>
                <div className="form-sub-header margin-bottom-20">
                  Note : &nbsp; Please choose the optional holiday that you
                  would like to take in this year.
                </div>

                <div className="form-input-label">
                  <span className="margin-top-20 Select-the-Long-Leav">
                    {`You can select max ${this.state.maxoptlimit} optional holidays.`}
                  </span>
                </div>

                <MenuList className="margintop-30 ">
                  <div>
                    {this.state.holidayList.map((item) => {
                      selectedOption = selectedOptions.filter(
                        (x) => x.holidayid == item.holidayid,
                      );

                      return (
                        <div>
                          <MenuItem
                            key={item.holidayid}
                            tabIndex="1"
                            autofocus
                            className={classNames(
                              "bottom-border",
                              selectedOption.length != 0
                                ? "select-list-item"
                                : "",
                            )}
                            onClick={this.HandleMultiSelect.bind(
                              this,
                              item,
                              true,
                            )}
                          >
                            <ListItemText
                              className="no-padding"
                              inset
                              primary={
                                `${item.holidayname} ` +
                                `-` +
                                ` ${getFormattedDate(item.holidaydate)}`
                              }
                            />
                            {/* {selectedOptions.length<=this.state.maxoptlimit? */}
                            <React.Fragment>
                              {selectedOptions.map((selectedId) =>
                                selectedId.holidayid == item.holidayid ? (
                                  <div>
                                    <img
                                      src={ActiveIcon}
                                      alt="icon"
                                      height="20"
                                    />
                                  </div>
                                ) : null,
                              )}
                            </React.Fragment>
                            {/* :
                                this.props.enqueueSnackbar("Your optional holiday limt", { variant: 'success' })} */}
                          </MenuItem>
                        </div>
                      );
                    })}{" "}
                  </div>
                </MenuList>

                <div>
                  {this.state.errors.leaveTypes ? (
                    <span className="caption-error">
                      {" "}
                      <FormattedMessage
                        id="ErServices"
                        defaultMessage="select optional holiday"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="draftbutton-wrapper" style={{ right: 75 }}>
                <div
                  className="draftclosebutton1"
                  tabIndex="8"
                  onClick={() => this.OnCancel()}
                >
                  <span className="floatleft" style={{ marginLeft: 6 }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </span>
                  <span className="draftclosebutton-text">
                    <FormattedMessage id="BtClose" defaultMessage="Close" />
                  </span>{" "}
                </div>

                <div
                  className="draftbutton-innerwrapper cursour-pointer"
                  onClick={this.onSaveClick.bind(this)}
                  disabled={this.state.isDisabelSaveButton}
                >
                  <span className="draftbutton-save">
                    <DoneAllIcon />
                    <span className="draft-option1">
                      <FormattedMessage id="BtSave" defaultMessage="Save" />
                    </span>
                  </span>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </IntlProvider>
    );
  }
}

UpdateOPtionalHoliday.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(UpdateOPtionalHoliday)));
